export const getUpdatedIntegrations = (
  userIntegrations,
  mappedUserIntegration,
  updatedMappedIntegration
) => {
  const isNewIntegration = !mappedUserIntegration.mapped_agent_id;
  if (isNewIntegration) {
    return [...userIntegrations, updatedMappedIntegration];
  }

  return userIntegrations.map((integration) => {
    if (
      integration.vendor_property_id ===
      updatedMappedIntegration.vendor_property_id
    ) {
      return updatedMappedIntegration;
    }
    return {
      ...integration,
    };
  });
};
